import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { VoicestormItem } from '../../models/voicestorm-item.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeHtmlPipe } from '../../../../modules/fwcore';

@Component({
  selector: 'app-news-item-popup',
  standalone: true,
  imports: [
    SafeHtmlPipe
  ],
  templateUrl: './news-item-popup.component.html',
  styleUrl: './news-item-popup.component.scss'
})
export class NewsItemPopupComponent implements AfterViewInit {
  @Input() title?: string;
  @Input() content?: string;
  @Input() imageSrc?: string;

  @ViewChild('scrollContainer') scrollContainer?: ElementRef;

  constructor(private modalService: NgbModal) {

  }

  ngAfterViewInit() {
    // Make sure the scroll container is scrolled to the top
    setTimeout(() => {
      if (this.scrollContainer) {
        this.scrollContainer.nativeElement.scrollTop = 0;
      }
    },5);
  }

  close(): void {
    this.modalService.dismissAll();
  }
}
